import { Button, styled } from "@material-ui/core";

export const PrimaryButton = styled(Button)({
  display: "flex",
  height: "44px",
  width: "100%",
  borderRadius: "8px",
  background: "#EE4360",
  color: "#FFFFFF",
  textTransform: "none",
  "&:hover": {
    background: "#D93451",
  },
  "& .MuiButton-label": {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontFamily: "'Inter', 'sans-serif'",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 700,
  },
  "&:disabled": {
    background: "#E4E4EA",
    color: "#C2C5DD",
  },
  // Dark mode (additive): brand CTA stays pink; only the disabled surface is
  // re-toned so it reads on a dark card. Light mode is untouched.
  ".dark &:disabled": {
    background: "hsl(var(--sds-muted))",
    color: "hsl(var(--sds-muted-foreground))",
  },
});

export const SecondaryButton = styled(Button)({
  display: "flex",
  height: "44px",
  width: "100%",
  borderRadius: "8px",
  background: "#FFFFFF",
  color: "#2E3860",
  border: "1px solid #E2E2FC",
  textTransform: "none",
  "&:hover": {
    background: "#F5F5F5",
  },
  "& .MuiButton-label": {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontFamily: "'Inter', 'sans-serif'",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 700,
  },
  "&:disabled": {
    background: "#E4E4EA",
    color: "#C2C5DD",
  },
  // Dark mode (additive): outline button becomes card-toned with a token border
  // and legible foreground text. Light mode is untouched.
  ".dark &": {
    background: "hsl(var(--sds-card))",
    color: "hsl(var(--sds-foreground))",
    borderColor: "hsl(var(--sds-border))",
  },
  ".dark &:hover": {
    background: "hsl(var(--sds-accent))",
  },
  ".dark &:disabled": {
    background: "hsl(var(--sds-muted))",
    color: "hsl(var(--sds-muted-foreground))",
    borderColor: "hsl(var(--sds-border))",
  },
});
